export default __webpack_public_path__ + "static/media/slot15.28a76434.png";